import { ReactElement } from "react";
import { Col } from "antd";
import { useSelector } from "react-redux";
import { ViewState, GroupingState, IntegratedGrouping } from "@devexpress/dx-react-scheduler";
import { Scheduler, Resources, Appointments, GroupingPanel, DayView } from "@devexpress/dx-react-scheduler-material-ui";
import { useTranslation } from "react-i18next";
import { getBookingState } from "../../redux/selectors";
import { timeToNumber } from "../../utils/string";

export default function BookingStatus(props: any): ReactElement {

	const { showSchedule, loading, schedule, grouping, dateInterval, resources } = props;
	const { t } = useTranslation();
	const { preBranch, preBookingDate } = useSelector(getBookingState);

	const startTimeForDouble = timeToNumber(preBranch?.startTime);
	const endTimeForDouble = timeToNumber(preBranch?.endTime);

	return (
		<Col sm={24} md={16} className={`booking-calendar-container ${showSchedule ? "show" : "hide"}`}>
			<div className="booking-header-title text-label">
				<span className="text-uppercase">{t("booking.booking_status")}</span>
				<p style={{ fontSize: 14, marginBottom: 0, fontWeight: 400 }}>{preBranch?.clubData.name}, {preBranch?.location}</p>
			</div>
			{!loading && (
				<Scheduler data={schedule}>
					<ViewState currentDate={preBookingDate} />
					<GroupingState grouping={grouping} />
					<DayView
						startDayHour={0}
						endDayHour={24}
						cellDuration={60}
						intervalCount={dateInterval}
					/>
					<Appointments />
					<Resources data={resources} mainResourceName="courts" />
					<IntegratedGrouping />
					<GroupingPanel />
				</Scheduler>
			)}
		</Col>
	);
}